import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';
import AddLocation from '../../components/admincomponents/AddLocation';

function AddProject({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <AddLocation />            
    </>
  );
}

export default AddProject;
